import { render, staticRenderFns } from "./PartnerNew.vue?vue&type=template&id=08017660&"
import script from "./PartnerNew.vue?vue&type=script&lang=ts&"
export * from "./PartnerNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports